import constant from '../../constant';


const setShareWechatDialog = (params = {}) => {
  return {
    type: constant.COMMON.SHARE_WECHAT_DIALOG,
    isShowShare: params.isShowShare,
    shareType: params.shareType
  }
}


export default {
  setShareWechatDialog
}